module.exports = "<div class=\"fadingPanel js-fading-panel\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/services/window/templates/PopupStack.hbs
// module id = 716
// module chunks = 0